import { render, staticRenderFns } from "./SupplierDirectInvoiceDocs.vue?vue&type=template&id=27477df0&"
import script from "./SupplierDirectInvoiceDocs.vue?vue&type=script&lang=js&"
export * from "./SupplierDirectInvoiceDocs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports